import React, { useState, useEffect } from 'react';
import { NavLink, useParams} from 'react-router-dom';
import ConstruirPdfAyudaHumanitaria from './ConstruirPdfAyudaHumanitaria';
import { ConsultarDatosGeneracionActaAyudaHumanitaria } from '../../../Auth/ConsultasApi';
import { useAuth } from '../../../Auth/AuthContext';

export default function GenerarPdfAyudaHumanitaria(){
    const { token, rol, user } = useAuth();
    const { id } = useParams();
    const { idPersona } = useParams();
    const { idCabezaFamilia } = useParams();
    const [pdfFile, setPdfFile] = useState(null);
    const [numPages, setNumPages] = useState(null);

    const handleGeneratePdf = (datosacta, encabezado, formularioactaentrega) => { 
        const url = ConstruirPdfAyudaHumanitaria(datosacta, encabezado, formularioactaentrega); 
        setPdfFile(url); 
    };

    const fetchData = async (id, rol) => {
        const obj = {idatencion: id, usrRolid: rol, usrId: user }
        try {
            setCargando(true);
            const response = await ConsultarDatosGeneracionActaAyudaHumanitaria({obj, token});
            const result = await response.data;
            
            if(result.datosacta && result.datosacta.length > 0){
                handleGeneratePdf(result.datosacta, result.encabezado, result.formularioactaentrega);
            }
        } catch (error) {
            
            console.error('Error fetching data:', error);
        } finally {
            setCargando(false);
        }
    };

    useEffect(() => {
        fetchData(id, rol);
    }, [id, rol]);
    const [Cargando, setCargando] = useState(false);
    const onDocumentLoadSuccess = ({ numPages }) => {
        setNumPages(numPages);
      };
   
    return (
        <div className="content-wrapper">
            <section className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                    <div className="col-sm-6">
                        <h1 className="m-0">Acta de entrega</h1>
                    </div>
                    <div className="col-sm-6">
                        <ol className="breadcrumb float-sm-right">
                        <li className="breadcrumb-item"><NavLink to="/dashboard" >Inicio</NavLink></li>
                        {idCabezaFamilia !== "0" && <li className="breadcrumb-item"><NavLink to={`/caracterizacion/grupofamiliar/${idCabezaFamilia}`} >Grupo familiar</NavLink></li>}
                        <li className="breadcrumb-item active"> Acta de entrega</li>
                        </ol>
                    </div>
                    </div>
                </div>
            </section>
            <section className="content">
                <div className="container-fluid">
                      {Cargando && <div className="centered">
                        <div><progress value={null} /></div>
                      </div>}
                </div>
                {pdfFile && (
                    <>
                        <div style={{
                        width: '100%',
                        height: '80vh',
                        minHeight: 300,
                        maxHeight: '100vh',
                        display: 'flex',
                        flexDirection: 'column'
                        }}>
                        <iframe
                            src={pdfFile}
                            style={{
                            border: 'none',
                            width: '100%',
                            height: '100%',
                            minHeight: 300,
                            maxHeight: '100vh',
                            display: 'block'
                            }}
                            title="PDF acta"
                            allow="autoplay; encrypted-media"
                            loading="lazy"
                        />
                        </div>
                        <div style={{ textAlign: 'center', marginTop: 10 }}>
                        <a
                            href={pdfFile}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ color: '#007bff', fontWeight: 'bold' }}
                        >
                            Abrir PDF en otra pestaña
                        </a>
                        </div>
                    </>
                )}
            </section>
        </div>
    );
}